import React from 'react';
import cx from 'classnames';

import Button from '@app/common/components/Button';
import { BillingFrequencyToggleProps } from '../../types';
import { SubscriptionBillingPeriod } from '@app/config';

import styles from './BillingFrequencyToggle.module.scss';

const BillingFrequencyToggle: React.FC<BillingFrequencyToggleProps> = ({ value, onChange, className }) => {
    return (
        <div className={cx(styles.billingToggle, className)}>
            <span className={styles.billingLabel}>Bill me</span>
            <div className={styles.toggleButtons}>
                <Button
                    type="button"
                    onClick={() => onChange(SubscriptionBillingPeriod.MONTHLY)}
                    quaternary
                    className={cx(styles.toggleButton, { [styles.active]: value === SubscriptionBillingPeriod.MONTHLY })}
                >
                    Monthly
                </Button>
                <Button
                    type="button"
                    quaternary
                    onClick={() => onChange(SubscriptionBillingPeriod.YEARLY)}
                    className={cx(styles.toggleButton, { [styles.active]: value === SubscriptionBillingPeriod.YEARLY })}
                >
                    Yearly - <span className={styles.savingsText}>Save up to 10%</span>
                </Button>
            </div>
        </div>
    );
};

export default BillingFrequencyToggle;
